(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Slider-Cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".responsive-slider-track");
  const slides = document.querySelectorAll(".responsive-slide");
  const leftArrow = document.querySelector(".left-arrow");
  const rightArrow = document.querySelector(".right-arrow");
  const dots = document.querySelectorAll(".responsive-slider-dots .dot");

  let currentIndex = 0;

  function updatePosition() {
    const slideWidth = slides[0].offsetWidth + 20;
    track.style.transform = `translateX(-${slideWidth * currentIndex}px)`;
    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[currentIndex]) dots[currentIndex].classList.add("active");
  }

  function goToSlide(index) {
    const visibleSlides = window.innerWidth > 768 ? 3 : 1;
    const maxIndex = Math.max(0, slides.length - visibleSlides);
    currentIndex = Math.max(0, Math.min(index, maxIndex));
    updatePosition();
  }

  leftArrow?.addEventListener("click", () => {
    goToSlide(currentIndex - 1);
  });

  rightArrow?.addEventListener("click", () => {
    goToSlide(currentIndex + 1);
  });

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const index = parseInt(dot.getAttribute("data-index"));
      if (window.innerWidth <= 768) {
        const slide = document.querySelector(`#slide-${index}`);
        slide.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      } else {
        goToSlide(index);
      }
    });
  });

  track.addEventListener("scroll", () => {
    if (window.innerWidth <= 768) {
      const slideWidth = slides[0].offsetWidth;
      const index = Math.round(track.scrollLeft / slideWidth);
      dots.forEach(dot => dot.classList.remove("active"));
      if (dots[index]) dots[index].classList.add("active");
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) {
      updatePosition();
    }
  });

  updatePosition();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["call-for-paper-page"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper('.call-for-paper-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-box-sec-7"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".custom-feature-swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".custom-feature-swiper .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 5,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo_slider_aboutpages"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    var swiper = new Swiper(".logoSwiper", {
      loop: true, // duplicate slides to create infinite loop
      slidesPerView: 6,
      spaceBetween: 20,
      speed: 5000, // higher = slower, smoother
      autoplay: {
        delay: 0, // no waiting, continuous motion
        disableOnInteraction: false, // resume after swipe
      },
      freeMode: true, // allow natural dragging
      freeModeMomentum: false, // prevent snapping
      allowTouchMove: true, // swipe works on mobile
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 20,
        }
      }
    });

    // force smooth linear scrolling
    const wrapper = document.querySelector(".logoSwiper .swiper-wrapper");
    if (wrapper) {
      wrapper.style.transitionTimingFunction = "linear";
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
